import { Grid } from '@mui/material';
import { useParams } from 'react-router-dom';
import { WebFormEmbedCode } from '../components/webFormEmbedCode';

export const WebFormsDetailEmbedPage = () => {
  const params = useParams();

  if (!params.name) return null;

  return (
    <Grid container spacing={2} sx={{ p: 3 }}>
      <WebFormEmbedCode webFormName={params.name} />
    </Grid>
  );
};
